import { ChangeEvent, useMemo, useState } from 'react';
import useTextInput, { ValidationLogic } from './useTextInput';
import i18n from '../../R/string/i18n';

const nameValidationLogics = (
  fieldLabel: 'lastName' | 'firstName'
): ValidationLogic[] => [
  {
    logic: (name: string) => name.length <= 0,
    msg:
      fieldLabel === 'lastName'
        ? i18n.userNameEditFormLastNameIsRequired()
        : i18n.userNameEditFormFirstNameIsRequired()
  },
  {
    logic: (name: string) => name.trim() !== name || !/^[A-Za-z ]+$/.test(name),
    msg: i18n.userNameEditFormEnterAlphabetsWithoutSymbols()
  }
];

function useNameInput(
  initVal: string,
  fieldLabel: 'lastName' | 'firstName'
): [
  string,
  (e: ChangeEvent<HTMLInputElement>) => void,
  string | undefined,
  React.Dispatch<React.SetStateAction<string>>,
  boolean,
  React.Dispatch<React.SetStateAction<boolean>>,
  () => void
] {
  const validationLogicsTranslated = nameValidationLogics(fieldLabel);
  const [isResetError, setIsResetError] = useState(false);

  const [name, onChangeName, nameErr, setName, setNotTouched] = useTextInput(
    initVal,
    validationLogicsTranslated,
    1000
  );

  const hasError = useMemo(
    () =>
      !isResetError &&
      validationLogicsTranslated.some(({ logic }) => logic(name)),
    [name, isResetError]
  );

  const clearError = () => {
    setIsResetError(true);
  };

  return [
    name,
    onChangeName,
    nameErr,
    setName,
    hasError,
    setNotTouched,
    clearError
  ];
}

export default useNameInput;
